

<app-page-header [title]="'Wallet'" [backLink]="['/wallet']"></app-page-header>

<nz-card>
    <form  [formGroup]="updateWallet">
        <nz-row [nzGutter]="16">

            <!-- Admin -->
            <nz-col [nzSpan]="8" *ngIf="['superadmin'].includes(role)">
              <nz-form-item>
                <nz-form-label nzFor="admin" [nzSpan]="24" class="left-align-label">Admin</nz-form-label>
                <nz-form-control>
                    <nz-select id="Admin" nzPlaceHolder="Select a user" formControlName="adminName" >
                    <nz-option *ngFor="let admin of Adminlist" [nzValue]="admin.label" [nzLabel]="admin.label" ></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </nz-col>
            <!-- Reseller -->
            <nz-col [nzSpan]="8" *ngIf="['superadmin','admin'].includes(role)">
              <nz-form-item>
                <nz-form-label nzFor="reseller" [nzSpan]="24" class="left-align-label">Reseller</nz-form-label>
                <nz-form-control>
                    <nz-select id="Reseller" nzPlaceHolder="Select a user" formControlName="resellerName" (ngModelChange)="onResellerChange($event)">
                    <nz-option *ngFor="let reseller of ResllerList" [nzValue]="reseller.label" [nzLabel]="reseller.label" ></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </nz-col>
      
            <!-- Seller -->
            <nz-col [nzSpan]="8" *ngIf="['superadmin','admin', 'reseller'].includes(role)">
              <nz-form-item>
                <nz-form-label nzFor="seller" [nzSpan]="24" class="left-align-label">Seller</nz-form-label>
                <nz-form-control>
                    <nz-select id="Seller" nzPlaceHolder="Select a user" formControlName="sellerName" (ngModelChange)="onSellerChange($event)">
                   >
                    <nz-option *ngFor="let seller of SellerList" [nzValue]="seller.label" [nzLabel]="seller.label"></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </nz-col>
      
            <!-- Client -->
            <nz-col [nzSpan]="8" *ngIf="['superadmin','admin', 'reseller', 'seller'].includes(role)">
              <nz-form-item>
                <nz-form-label nzFor="client" [nzSpan]="24" class="left-align-label">Client</nz-form-label>
                <nz-form-control>
                    <nz-select id="Client" nzPlaceHolder="Select a user"  formControlName="clientName" (ngModelChange)="onClientChange($event)"> >
                    <nz-option *ngFor="let Client of Clientlist" [nzValue]="Client.label" [nzLabel]="Client.label" ></nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </nz-col>
        
          <nz-col [nzSpan]="8">
            <nz-form-item>
              <nz-form-label nzFor="client" [nzSpan]="24" class="left-align-label">Sellect Billing Plan</nz-form-label>
              <nz-form-control>
                  <nz-select id="Client" nzPlaceHolder="Select Plan" formControlName="walletPlanName">
                  <nz-option *ngFor="let name of plans" [nzLabel]="name" [nzValue]="name" ></nz-option>
        
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </nz-col>


       <!-- Logged In User Wallet -->
<nz-col [nzSpan]="8">
  <nz-form-item>
    <nz-form-label nzFor="loggedInUserWallet" [nzSpan]="24" class="left-align-label">
      Your Wallet Balance
    </nz-form-label>
    <nz-form-control>
      <input
        nz-input
        id="loggedInUserWallet"
        placeholder="Your Wallet Balance"
        [value]="loggedInUserWallet"
        [disabled]="true"
      />
    </nz-form-control>
  </nz-form-item>
</nz-col>

<!-- Selected User Wallet -->
<nz-col [nzSpan]="8">
  <nz-form-item>
    <nz-form-label nzFor="userAvailableWallet" [nzSpan]="24" class="left-align-label">
      User Wallet Balance
    </nz-form-label>
    <nz-form-control>
      <input
        nz-input
        id="userAvailableWallet"
        placeholder="User Wallet Balance"
        [value]="userAvailableWallet"
        [disabled]="true"
      />
    </nz-form-control>
  </nz-form-item>
</nz-col>



          <nz-col [nzSpan]="8">
            <nz-form-item>
              <nz-form-label nzFor="client" [nzSpan]="24" class="left-align-label">Add Wallet Balance</nz-form-label>
              <nz-form-control>
                <input nz-input placeholder="Add Wallet Blance" formControlName="balanceAdded" />
              </nz-form-control>
            </nz-form-item>
          </nz-col>
          <nz-col [nzSpan]="8">
            <nz-form-item>
              <nz-form-label nzFor="Comment" [nzSpan]="24" class="left-align-label">Comment</nz-form-label>
              <nz-form-control>
                <input nz-input formControlName="remarks"  />
              </nz-form-control>
            </nz-form-item>
          </nz-col>
          </nz-row>

          

          <nz-row class="button-container">
            <nz-col [nzSpan]="24" style=" display: flex; justify-content: center; gap: 10px;">
              <button nz-button nzType="primary" (click)=" updateWalletData()">Add Balance</button>
              <button nz-button nzType="default" nzDanger (click)="updateWallet.reset()">Reset</button>
            </nz-col>
          </nz-row>
          
          
    




        </form>
</nz-card>